// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"61456da3","879":"7998eca3"}[chunkId] + ".chunk.js";
};